// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileExcelTwoToneSvg from "@ant-design/icons-svg/es/asn/FileExcelTwoTone";
import AntdIcon from '../components/AntdIcon';

var FileExcelTwoTone = function FileExcelTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileExcelTwoToneSvg
  }));
};

FileExcelTwoTone.displayName = 'FileExcelTwoTone';
export default React.forwardRef(FileExcelTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileExcelTwoTone.js
// module id = 1097
// module chunks = 0